export const fetchTranslations = async (getTranslations, locale, callback) => {
    const translations = await getTranslations(locale);
    callback(translations);
};
